const DownloadIcon = () => {
  return (
    <svg id="dowloadIcon" width="24" height="22" viewBox="0 0 24 22" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M22.4992 14.5625C22.0492 14.5625 21.6367 14.9375 21.6367 15.425V18.7625C21.6367 19.1 21.3742 19.3625 21.0367 19.3625H2.96172C2.62422 19.3625 2.36172 19.1 2.36172 18.7625V15.425C2.36172 14.975 1.98672 14.5625 1.49922 14.5625C1.01172 14.5625 0.636719 14.9375 0.636719 15.425V18.7625C0.636719 20.0375 1.64922 21.05 2.92422 21.05H21.0367C22.3117 21.05 23.3242 20.0375 23.3242 18.7625V15.425C23.3617 14.9375 22.9492 14.5625 22.4992 14.5625Z"
        fill="#1F2A37"
      />
      <path
        d="M11.399 15.4625C11.549 15.6125 11.774 15.6875 11.999 15.6875C12.224 15.6875 12.4115 15.6125 12.599 15.4625L17.9615 10.25C18.299 9.91245 18.299 9.38745 17.999 9.04995C17.6615 8.71245 17.1365 8.71245 16.799 9.01245L12.8615 12.875V1.81245C12.8615 1.36245 12.4865 0.949951 11.999 0.949951C11.549 0.949951 11.1365 1.32495 11.1365 1.81245V12.875L7.19903 9.04995C6.86153 8.71245 6.33653 8.74995 5.99903 9.04995C5.66153 9.38745 5.69903 9.91245 5.99903 10.25L11.399 15.4625Z"
        fill="#1F2A37"
      />
    </svg>
  );
};

export const DownloadWithHoverIcon = () => {
  return (
    <svg
      className="hover:text-darkblue text-[#9CA3AF]"
      width="24"
      height="22"
      viewBox="0 0 24 22"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M22.4992 14.5625C22.0492 14.5625 21.6367 14.9375 21.6367 15.425V18.7625C21.6367 19.1 21.3742 19.3625 21.0367 19.3625H2.96172C2.62422 19.3625 2.36172 19.1 2.36172 18.7625V15.425C2.36172 14.975 1.98672 14.5625 1.49922 14.5625C1.01172 14.5625 0.636719 14.9375 0.636719 15.425V18.7625C0.636719 20.0375 1.64922 21.05 2.92422 21.05H21.0367C22.3117 21.05 23.3242 20.0375 23.3242 18.7625V15.425C23.3617 14.9375 22.9492 14.5625 22.4992 14.5625Z"
        fill="currentColor"
      />
      <path
        d="M11.399 15.4625C11.549 15.6125 11.774 15.6875 11.999 15.6875C12.224 15.6875 12.4115 15.6125 12.599 15.4625L17.9615 10.25C18.299 9.91245 18.299 9.38745 17.999 9.04995C17.6615 8.71245 17.1365 8.71245 16.799 9.01245L12.8615 12.875V1.81245C12.8615 1.36245 12.4865 0.949951 11.999 0.949951C11.549 0.949951 11.1365 1.32495 11.1365 1.81245V12.875L7.19903 9.04995C6.86153 8.71245 6.33653 8.74995 5.99903 9.04995C5.66153 9.38745 5.69903 9.91245 5.99903 10.25L11.399 15.4625Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default DownloadIcon;
